<template>
  <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
      <v-snackbar v-model="snackbar" :color="snackbar_color" :timeout="2000" >
        <span>{{message}}</span>
        <template v-slot:action="{ attrs }">
          <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <v-card class="neu-glow">
        <v-card-title primary-title>
          <div class="text-h5">{{$t(page+'.User')}}</div>
        </v-card-title>       
        <v-container grid-list-xl fluid>
          <v-row>
            <v-col md="6" cols="12">
              <v-text-field
                color="primary"
                :label="$t(page+'.Username')"
                outlined
                dense
                readonly
                clearable
                clear-icon="far fa-trash-alt" 
                @click:clear="$parent.save(null,'Username')"                 
                name="Username"
                @input.native="$parent.save"
                v-model="form.Username"
                @blur="$v.form.Usename.$touch()"
                required
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12">
              <v-text-field
                color="primary"
                :label="$t(page+'.Email')"
                outlined
                dense
                clearable
                clear-icon="far fa-trash-alt" 
                @click:clear="$parent.save(null,'Email')"                 
                name="Email"
                @input.native="$parent.save"
                :value="form.Email"
                @blur="$v.form.Email.$touch()"
                required
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12">
              <v-text-field
                color="primary"
                :label="$t(page+'.First Name')"
                outlined
                dense
                clearable
                clear-icon="far fa-trash-alt" 
                @click:clear="$parent.save(null,'FirstName')"                 
                name="FirstName"
                @input.native="$parent.save"
                v-model="form.FirstName"
                @blur="$v.form.FirstName.$touch()"
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12">
              <v-text-field
                color="primary"
                :label="$t(page+'.Last Name')"
                outlined
                dense
                clearable
                clear-icon="far fa-trash-alt" 
                @click:clear="$parent.save(null,'LastName')"                 
                v-model="form.LastName"
                @blur="$v.form.LastName.$touch()"
                name="lastName"
                @input.native="$parent.save"
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12">
              <v-text-field
                color="primary"
                :label="$t(page+'.Mobile')"
                outlined
                dense
                clearable
                clear-icon="far fa-trash-alt" 
                @click:clear="$parent.save(null,'Mobile')" 
                name="Mobile"
                @input.native="$parent.save"
                v-model="form.Mobile"
                @blur="$v.form.Mobile.$touch()"
              ></v-text-field>
            </v-col>
            <v-col md="6">
              <v-select
                color="primary"
                :label="$t(page+'.Favorite Language')"
                v-model="form.LanguageID"
                required
                outlined
                dense
                clearable
                clear-icon="far fa-trash-alt" 
                @click:clear="$parent.save(null,'LanguageID')"                 
                name="LanguageID"
                @change="save($event, 'LanguageID')"
                :items="locales"
                @blur="$v.form.LanguageID.$touch()"
              ></v-select>
            </v-col>
            <v-col md="6">
              <v-select
                color="primary"
                :label="$t(page+'.Favorite Currency')"
                v-model="form.Currency"
                required
                outlined
                dense
                clearable
                clear-icon="far fa-trash-alt" 
                @click:clear="$parent.save(null,'Currency')"                 
                name="Currency"
                @change="save($event, 'Currency')"
                :items="Currencies"
                @blur="$v.form.Currency.$touch()"
              ></v-select>
            </v-col>
            <v-col md="6" cols="12">
              <avatar />
            </v-col>
          </v-row>
        </v-container>
      </v-card>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
import { required, email } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import { availableLocale, availableCurrency } from "@/config/locale";
import { availableTimeZones  } from "@/config/timezones";
import avatar from "./AvatarMain";
import _ from 'lodash'
const defaultForm = {
  username: "",
  email: "",
  first: "",
  last: "",
  mobile: "",
  job: "",
  currency: "",
  locale: "",
  timezone: "",
};

export default {
  props: ['form'],
  components:{
    avatar
  },
  mixins: [validationMixin],
  validations: {
    form: {
      username: {required},
      first: { required },
      last: { required },
      email: { required, email },
      mobile: { required },
      job: { required },
      locale: { required },
      currency: { required },
      timezone: { required }
    },
  },
  validationMessages: {
    form: {
      username: { required: "UserName is required" },
      first: { required: "First name is required" },
      last: { required: "Last name is required" },
      mobile: { required: "Mobile is required" },
      job: { required: "Job is required" },
      locale: { required: "Choose your favorite language" },
      currency: { required: "Choose your favorite currency" },
      timezone: { required: "Choose your favorite currency" },
      email: {
        required: "Email is required",
        email: "Email must be valid",
      }
    },
  },
  computed: {
      ...mapGetters(["user"]),
  },
  data() {
    return {
      page: "BossAccount",
      //form: this.$store.state.userdata.admin,
      //form: this.user,
      locales: availableLocale,
      currencies: availableCurrency,
      timezones:availableTimeZones,
      snackbar: false,     
      message:'',
      rtl: false,
      snackbar_color:'success', 
    };
  },
  methods: {
    resetForm() {
      this.form = Object.assign({}, defaultForm);
      this.$refs.form.reset();
      this.$v.$reset();
    },
    submit() {
      this.snackbar = true;
      this.resetForm();
      this.$v.$reset();
    },
  },
  beforeDestroy() {
    this.form = null;
    delete this.form;
  }
};
</script>
